import { render } from "./ProjectChangeProjStatusDialog.vue?vue&type=template&id=33c59ef7"
import script from "./ProjectChangeProjStatusDialog.vue?vue&type=script&lang=js"
export * from "./ProjectChangeProjStatusDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__